import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 180
    },
    grid: {
      minHeight: 400,
      width: '100%',
      backgroundColor: '#ebebeb',
      padding: 3,
      borderRadius: 10,
      alignContent: 'center'
    },
    buttonBar: {
      display: 'flex',
      flex: 3,
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    }
  })
)
